export default __webpack_public_path__ + "static/solutions-1-b10730c08231a612781bcbf7c0bfdb84.webp";